module.exports = __webpack_public_path__ + "static/fred_2-9f55b74271b7e160d3432397e3623001.jpg";